import axios from 'axios'
import request from '@/api/request'

/**
 * 获取签名
 * @param id
 */
export const getSignature = (type) => {
  const data = {
    isPrivate: type
  }
  return request({
    url: '/admin/file/admin/web/ossSignInfo',
    method: 'post',
    data
  })
}

export const ossAccountInfo = (type) => {
  const data = {
    isPrivate: type
  }
  return request({
    url: '/admin/file/admin/web/ossAccountInfo',
    method: 'post',
    data
  })
}

/**
 * **/
export const getpublicImgUrl = (fileName) => {
  const data = {
    fileName: fileName
  }
  return request({
    url: '/admin/file/admin/public/wholeUrl',
    data,
    method: 'post'
  })
}

export const getPrivateImgUrl = (fileName) => {
  const data = {
    fileName: fileName
  }
  return request({
    url: '/admin/file/admin/personal/wholeUrl',
    data,
    method: 'post'
  })
}

// 生成随机字符串
function randomString(len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}
// 获取用户上传原始文件名
function getFileName(filename) {
  const pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos !== -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}
//  把随机生成的字符串拼接在原始上传文件名后面生成新的唯一文件名
function setFileName(filename, key) {
  const suffix = getFileName(filename)
  return key + randomString(10) + suffix
}

/**
 * 上传阿里云
 *
 * @param {*} data { isPrivate }
 * @return {*} Object
 */
const uploadOss = (data, file, isPrivate) => {
  const { host, OSSAccessKeyId, policy, signature, key } = data || {}
  const formData = new FormData()
  formData.append('OSSAccessKeyId', OSSAccessKeyId)
  formData.append('policy', policy)
  formData.append('Signature', signature)
  formData.append('key', key)
  formData.append('success_action_status', 200)
  formData.append('file', file)
  return new Promise((resolve, reject) => {
    axios({
      url: host,
      header: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: formData
    }).then(() => {
      if (isPrivate === 0) {
        getpublicImgUrl(key).then(({ code, data }) => {
          if (code === 0) {
            resolve(data)
          }
          reject(new Error())
        })
      } else {
        getPrivateImgUrl(key).then(({ code, data }) => {
          if (code === 0) {
            resolve(data)
          }
          reject(new Error())
        })
      }
    }).catch(() => {
      reject(new Error())
    })
  })
}

// 获取后端返回的签名信息，生成oss参数
const oss = (file, isPrivate, path) => {
  const { name: filename } = file
  // 调用后端服务器接口获取签名信息，利用axios返回promise，可以链式调用
  return getSignature(isPrivate).then(({ code, data }) => {
    if (code === 0) {
      const { host, policy, signature, accessid } = JSON.parse(data)
      const key = setFileName(filename, path)
      // 返回表单上传需要的参数信息
      const option = {
        key,
        host,
        policy,
        signature,
        OSSAccessKeyId: accessid,
        success_action_status: '200'
      }
      return uploadOss(option, file, isPrivate)
    }
    return Promise.reject(new Error())
  })
}

export default oss
